import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/DewittLogo.webp";
import "../Styles/Header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`main-header ${isScrolled ? "scrolled" : ""} ${isOpen ? "open" : ""}`}
    >
      <div className="header-glass-line" />
      <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }} />

      <div className="nav-container">
        <NavLink to="/" className="logo-container" onClick={closeMenu}>
          <img
            src={Logo}
            alt="DeWitt Solutions"
            className="logo"
            width="90"
            height="90"
            fetchpriority="high"
          />
        </NavLink>

        {/* Mobile Toggle */}
        <div
          className={`menu-icon ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
          role="button"
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
          aria-controls="main-nav"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Navigation Menu */}
        <nav id="main-nav" className={isOpen ? "open" : ""} aria-label="Main navigation">
          <div className="nav-links-wrapper">
            <NavLink
              to="/"
              end
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Home
            </NavLink>
            <NavLink
              to="/web-development"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Web Development
            </NavLink>
            <NavLink
              to="/capabilities"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Capabilities
            </NavLink>
            <NavLink
              to="/about"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              About
            </NavLink>
            <NavLink
              to="/case-studies"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Case Studies
            </NavLink>
            <NavLink
              to="/contact"
              onClick={closeMenu}
              className="nav-cta-button button-shimmer"
            >
              Contact Us
            </NavLink>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
